import { render, staticRenderFns } from "./FinalTicket.vue?vue&type=template&id=1553ecd4"
import script from "./FinalTicket.vue?vue&type=script&lang=js"
export * from "./FinalTicket.vue?vue&type=script&lang=js"
import style0 from "./FinalTicket.vue?vue&type=style&index=0&id=1553ecd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports